<template>
  <div class="p-4 glass-frosted h-full flex flex-col rounded-8xl">
    <p class="text-black-white text-l-medium mb-3">{{ $t('parameters.reportRate.title') }}</p>
    <!-- TODO:  -->
  </div>
</template>

<script setup lang="ts">
  import type { ModuleSize } from '../utils/types'

  defineProps<{
    size?: ModuleSize
  }>()
</script>
